var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"px-12 py-8 my-2 round-corner",attrs:{"color":"amber darken-2","dark":"","x-large":"","block":""},on:{"click":_vm.cloneCollection}},[_vm._v("\n  Fazer backup de usuários\n")])}
var staticRenderFns = []

export { render, staticRenderFns }